export default __webpack_public_path__ + "static/media/symphony.53b26045.png";